import Vue from 'vue'
const files = require.context('.', false, /\.vue$/)
const modules: any = {}
files.keys().forEach((key) => {
    modules[key.replace(/(\.\/|\.vue)/g, '')] = files(key)
})
Object.entries(modules).forEach(([name]) => Vue.component(name, () => import(`./${name}.vue`)))
export default modules
